export default __webpack_public_path__ + "static/media/231-libya.9456968a.svg";